/* tslint:disable */
/* eslint-disable */
/**
 * COTATO 프로젝트 API 명세서
 * api 명세서
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CotatoProjectImageInfoResponseProjectImageTypeEnum = {
    Logo: 'LOGO',
    Thumbnail: 'THUMBNAIL',
    Detail: 'DETAIL'
};
/**
 * Check if a given object implements the CotatoProjectImageInfoResponse interface.
 */
export function instanceOfCotatoProjectImageInfoResponse(value) {
    return true;
}
export function CotatoProjectImageInfoResponseFromJSON(json) {
    return CotatoProjectImageInfoResponseFromJSONTyped(json, false);
}
export function CotatoProjectImageInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'projectImageType': json['projectImageType'] == null ? undefined : json['projectImageType'],
        'imageOrder': json['imageOrder'] == null ? undefined : json['imageOrder'],
    };
}
export function CotatoProjectImageInfoResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
        'projectImageType': value['projectImageType'],
        'imageOrder': value['imageOrder'],
    };
}
